import styles from "./BlogDetail.module.scss";
import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import _sendAPIRequest from "../../../helpers/api";
import { WebsiteApiUrls } from "../../../helpers/api-urls/WebsiteApiUrls";
import ScreenLoader from "../../../elements/CustomScreeenLoader/ScreenLoader";
import { AlertContext } from "../../../contexts/AlertProvider";
import DOMPurify from "../../../utils/DomPurifier";
import useScrollToHash from "../../../helpers/useScrollToHash";
import { fetchBlogList } from "../../../helpers/common";

const BlogDetail = () => {
  useScrollToHash({ targetSection: "blog-details" });
  const { slug } = useParams();
  const [blogDetail, setBlogdetail] = useState({});
  const [screenLoader, setScreenLoader] = useState(true);
  const { setAlert } = useContext(AlertContext);
  const [blogs, setBlogs] = useState([]);

  const fetchBlogDetails = async () => {
    try {
      const response = await _sendAPIRequest(
        "GET",
        `${WebsiteApiUrls.WEBSITE_BLOG_DETAIL}${slug}/`,
        "",
        true
      );
      if (response) {
        setBlogdetail(response.data);
        setScreenLoader(false);
      }
    } catch (error) {
      setAlert({
        isVisible: true,
        message: "Something went wrong",
        severity: "error",
      });
    }
  };
  const loadBlogs = async () => {
    const list = await fetchBlogList();
    setBlogs(list || []);
  };

  useEffect(() => {
    fetchBlogDetails();
    loadBlogs();
  }, [slug]);

  if (screenLoader) {
    return <ScreenLoader />;
  }

  return (
    <>
      <div className={styles["banner"]}>
        <img
          src={blogDetail?.banner_image}
          alt="BlogBanner"
          className={styles["blog-banner-img"]}
        />
      </div>

      <div className="container mt-5" id="blog-details">
        <div className="row g-5">
          <div className="col-lg-9 col-md-8">
            <div className={styles["blog-content-box"]}>
              <img
                src={blogDetail?.cover_image}
                alt="Cover"
                className={styles["blog-cover-img"]}
              />
              <div className="mt-4">
                <div className={styles["blog-title-wrapper"]}>
                  <h2 className={styles["blog-title"]}>{blogDetail?.title}</h2>
                  <span className={styles["blog-title-underline"]}></span>
                </div>
                <div className={styles["blog-description-wrapper"]}>
                  <div
                    className={styles["blog-description"]}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(blogDetail?.description),
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className={styles["latest-blogs-box"]}>
              <h5 className={styles["section-title"]}>Latest Blogs</h5>
              <ul className={styles["styled-list"]}>
                {blogs?.map((blog, i) => (
                  <li key={i + 1}>
                    <NavLink to={`/blogs/${blog.slug}#blog-details`}>
                      <span className="arrow">→</span> {blog.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
